import { useEffect, useState } from 'react';
import InfoSidebar from '../../../../../features/InfoSidebar/InfoSidebar';
import NotFound from '../../../../../features/NotFound/NotFoundPage';
import { ButtonPest } from '../../../../../utils/Button';
import PackagesTable from './PackagesTable/PackagesTable';
import PricingTable from './PricingTable/PricingTable';

function PackageInfoTitle({ title }) {
    return (
        <div className="py-2.5 px-5 bg-slate-300 rounded-10 mb-6">
            <h2 className="text-primary text-xl font-medium">{title || '--'}</h2>
        </div>
    );
}

function TabButton({ title, onClick, isActive }) {
    return (
        <button
            type="button"
            className={`text-xl font-medium ${
                isActive ? 'text-primary' : 'text-[rgba(4,43,58,0.30)]'
            }`}
            onClick={onClick}
        >
            {title}
        </button>
    );
}

function PackageInfo({ packageInfo, isSelected, openModal, isServiceInactive }) {
    const [tabIndex, setTabIndex] = useState(2);

    if (!isSelected) {
        return (
            <div className="mt-6">
                <NotFound
                    title="No Package Selected!"
                    btnTitle=""
                    evButtonClick={null}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="w-full">
            <PackageInfoTitle title={packageInfo?.packageName} />
            <div className="flex gap-x-7 mb-4 justify-between items-center">
                <TabButton
                    title="Pricing"
                    onClick={() => setTabIndex(2)}
                    isActive={tabIndex === 2}
                />
                <ButtonPest
                    title="Add +"
                    disabled={isServiceInactive}
                    onClick={() => openModal('addPrice')}
                />
            </div>
            <PricingTable show={tabIndex === 2} />
        </div>
    );
}

function PageTables({ serviceInfo, openModal, isSelected, isClicked, packageInfo }) {
    const [showMenu, setShowMenu] = useState(false);

    const isServiceInactive = serviceInfo?.status === 'inactive';

    // if any package selected then show info sidebar
    useEffect(() => {
        if (isSelected) setShowMenu(true);
    }, [isSelected, isClicked]);

    if (serviceInfo && serviceInfo?.packages?.length === 0) {
        return (
            <div className="mt-16">
                <NotFound
                    title="No Package Found!"
                    btnTitle="Add Package"
                    evButtonClick={() => openModal('addPackage')}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="flex overflow-hidden h-full">
            <div className="w-full overflow-y-auto transition-all duration-[600ms] ease-in-out">
                <div className="mb-3 flex items-center justify-between">
                    <h2 className="text-primary text-xl font-medium">List Of Packages</h2>
                    <ButtonPest
                        title="Add Package +"
                        disabled={isServiceInactive}
                        onClick={() => openModal('addPackage')}
                    />
                </div>
                <PackagesTable />
            </div>

            <InfoSidebar
                show={showMenu}
                setShow={setShowMenu}
                className="lg:w-[70%] 2xl:w-[60%] 4xl:w-1/2"
            >
                <PackageInfo
                    packageInfo={packageInfo}
                    isSelected={isSelected}
                    openModal={openModal}
                    isServiceInactive={isServiceInactive}
                />
            </InfoSidebar>
        </div>
    );
}

export default PageTables;
